(ns nl.mediquest.questionnaire-frontend.component.privacy
  (:require
   [nl.mediquest.questionnaire-frontend.component.i18n :as i18n]
   [nl.mediquest.questionnaire-frontend.config :as config]))

(defn- default-panel []
  [:div.m-4
   [:p.text-xl "Jouw privacy"]
   [:p "De scan wordt uitgevoerd door onafhankelijk onderzoeksbureau Mediquest.
        Alle gegevens worden vertrouwelijk verwerkt door Mediquest, volgens de
        huidige wet- en regelgeving."]
   [:p "Deelname aan de scan is geheel vrijwillig. Je werkgever weet niet of je
        deelneemt. Ook kan je werkgever niet zien welke antwoorden je hebt
        gegeven. Resultaten worden alleen verstrekt aan jouw werkgever als er
        minimaal tien ingevulde scans zijn en worden op groepsniveau getoond.
        Dit betekent dat de resultaten niet te herleiden zijn naar jou als
        persoon."]
   [:p.text-xl.mt-8 "Wat gebeurt er met jouw gegevens?"]
   [:p "Als je meedoet aan de scan dan geef je Mediquest eerst toestemming om
        je gegevens te verwerken en op groepsniveau terug te koppelen naar:"]
   [:ul.list-disc
    [:li.ml-4 "Je werkgever in een totaalrapport om een passend
               vitaliteitsprogramma te kunnen samenstellen. De resultaten in
               dit rapport zijn pas zichtbaar als er tien ingevulde scans zijn
               en hierdoor niet te herleiden naar jou als persoon."]
    [:li.ml-4 "Mediquest t.b.v. analyse en onderzoek
               van de vragenlijsten, behoefte en aansluiting van het aanbod op
               de behoefte. De resultaten zijn niet te herleiden naar jou als
               persoon en niet naar het bedrijf waar je voor werkt."]]
   [:p.mt-4 "Het volledige privacy statement kun je "
    [:a {:href
         "https://home.mediquest.nl/privacy-statement/"
         :target "_blank"}
     "hier"]
    " downloaden."]])

(defn- vitaal-bedrijf-panel []
  [:div.m-4
   [:p.text-xl [i18n/text :privacy/your-privacy]]
   [:p [i18n/text :privacy/independent]]
   [:p [i18n/text :privacy/voluntary]]
   [:p.text-xl.mt-8 [i18n/text :privacy/what-happens]]
   [:p [i18n/text :privacy/permission]]
   [:ul.list-disc
    [:li.ml-4 [i18n/text :privacy/not-traceable]]
    [:li.ml-4 [i18n/text :privacy/analysis]]]
   [:p.mt-4 [i18n/text :privacy/full-statement]
    [:a.underline {:href
                   "https://home.mediquest.nl/wp-content/uploads/vitaliteitsscan-privacy-statement-.docx.pdf"
                   :target "_blank"}
     [i18n/text :privacy/here]]
    " " [i18n/text :privacy/download]]])

(defn privacy-panel []
  (if config/vitaliteitsscan?
    [vitaal-bedrijf-panel]
    [default-panel]))
